export default __webpack_public_path__ + "static/media/IconArrowDropDown.5021ecde.svg";